export enum eBatchExpiredStatus{
    'Vigente' = 1,
    'Próximo a vencer' = 2,
    'Vencido' = 3
}

export enum eBatchControl{
    'Sin Fefo' = 1,
    'Con fefo' = 2
}

export enum eIsGreenSale{
    'Si' = 1,
    'No' = 2
}

export enum eBatchState {
    Created = 1,
    Pending = 2,
    Storing = 3,
    Finished = 4
}